var nunjucks = require("nunjucks/browser/nunjucks-slim");
var env;
if (!nunjucks.currentEnv){
	env = nunjucks.currentEnv = new nunjucks.Environment([], { autoescape: true });
} else {
	env = nunjucks.currentEnv;
}
var dependencies = nunjucks.webpackDependencies || (nunjucks.webpackDependencies = {});




var shim = require("/home/travis/build/SouthAmericansSecrets/web/node_modules/nunjucks-loader/runtime-shim");


(function() {(nunjucks.nunjucksPrecompiled = nunjucks.nunjucksPrecompiled || {})["partials/article-sidebar.en.njk"] = (function() {
function root(env, context, frame, runtime, cb) {
var lineno = 0;
var colno = 0;
var output = "";
try {
var parentTemplate = null;
output += "<div class=\"banner-right floating-right\">\n  <a href=\"packagecoast.html#package-mystery-south-coast\" class=\"ad\">\n    <div class=\"title\">\n      Nazca Lines & South Coast\n      <div class=\"gallery autoplay items-1\">\n        <div id=\"item-1\" class=\"control-operator\"></div>\n        <figure class=\"item\">\n            <div class=\"banner-img nazca-lines\">\n            </div>\n        </figure>\n      </div>\n      <div class=\"tour-info-title\">2 days / 1 night</div>\n      <div class=\"tour-info-title\"><h4>$565.00 USD</h4></div>\n      <div class=\"tour-info-title\">per person from Lima transport & hotel included</div>\n      <p style=\"font-size:14px;\">\n        <b>Short on time?</b> Get the most out of your vacation with <b>ease, comfort &amp; style</b>:<br>\n        Flight over Nazca lines, guided tour Paracas National Reserve, excursion to Ballestas Islands, visit a winery in Ica, visit Huacachina oasis and a thrilling dune buggy. <br> The price also includes *all* transport, transfers, and fees! From your hotel in Lima!\n      </p>\n    </div>\n  </a>\n</div>\n";
if(parentTemplate) {
parentTemplate.rootRenderFunc(env, context, frame, runtime, cb);
} else {
cb(null, output);
}
;
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
return {
root: root
};

})();
})();



module.exports = shim(nunjucks, env, nunjucks.nunjucksPrecompiled["partials/article-sidebar.en.njk"] , dependencies)


//////////////////
// WEBPACK FOOTER
// ./app/tpl/partials/article-sidebar.en.njk
// module id = 51
// module chunks = 50 51 52 53 57 58 59 60 61 62 63 64